'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RequestBaseClass2 = require('./RequestBaseClass');

var _RequestBaseClass3 = _interopRequireDefault(_RequestBaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//const data = require('../../db.json');
var data = '';

var RequestJsonClass = function (_RequestBaseClass) {
    _inherits(RequestJsonClass, _RequestBaseClass);

    function RequestJsonClass(request) {
        _classCallCheck(this, RequestJsonClass);

        return _possibleConstructorReturn(this, (RequestJsonClass.__proto__ || Object.getPrototypeOf(RequestJsonClass)).call(this, request));
    }

    _createClass(RequestJsonClass, [{
        key: 'doRequest',
        value: function doRequest() {
            var request = this.request;
            request = request.replace("/", "");
            var idx = request.indexOf("?");
            if (idx > -1) {
                request = request.slice(0, idx);
            }
            var idx2 = request.indexOf("/");
            if (idx2 > -1) {
                request = request.slice(0, idx2);
            }
            var Data = {
                Data: data[request]
            };
            console.log(request);
            console.log(Data);
            if (this.readyCallback && typeof this.readyCallback === 'function') {
                this.readyCallback(Data);
            }
        }
    }]);

    return RequestJsonClass;
}(_RequestBaseClass3.default);

exports.default = RequestJsonClass;